import React, { Component } from 'react';
import { Button , Container , Icon , Header } from 'semantic-ui-react'; 

import * as constantes from '../../constantes';
import auth0Client from '../Auth/Auth'; 
const server = constantes.REST_API_PRIVATE;

export default class ActualizaCasosAntiguos extends Component{

    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false,
            error: null,
            resultado : ''
        };
        //this.onChange = this.onChange.bind(this);
    }
  
    componentDidMount() {
        auth0Client.isExpired();
        this.setState({
            isLoaded: true 
        });
    }

    ejecutarUpdate(){
        let METHODNAME = 'ejecutarUpdate - ';
        console.log(METHODNAME + 'INI');

        let url = server+`/procesoUpdate01` ; 

        fetch( 
            url , {
            method: 'GET',
            headers:{
                'Accept':'application/json',
                'Content-Type':'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('AccessToken'),
            } 
        })
        .then(res => res.json())
        .then(
            
            (result) => {
  
              if( result.resultado ){
                  console.log(METHODNAME + 'RESULTADO obtenido');
                  this.setState({
                      isLoaded: true, 
                      resultado : result.resultado 
                  });
                  this.cargarListaResultados( this.state.preguntaId );
              }else{
                  console.warn(METHODNAME +  'No se pudo procesar ' );
                  console.warn(METHODNAME +  'error : ' + result.error );
  
                  this.setState({
                      isLoaded: true,
                      error:result.error
                  });
              }
  
            },
            // Note: it's important to handle errors here
            // instead of a catch() block so that we don't swallow
            // exceptions from actual bugs in components.
            (error) => {
                console.log(METHODNAME + 'error = ' + error );
                this.setState({
                    isLoaded: true,
                    error
                });
            }
          )
          console.log(METHODNAME + 'FIN');
    }

    render() {

        const { error, isLoaded , resultado } = this.state;
    
        if (error) {
            return <div>Error: {error.message}</div>;
        } else if (!isLoaded) {
            return <div>Loading...</div>;
        } else {
            return(
                <Container>
                    <Header as='h2' content='Actualizar casos analizados antiguos' className='h2' textAlign='center' />
                    <div>Ejecutar una sola vez para actualizar el campo recien creado.  private/procesoUpdate01</div>
                       
                    <div>Resultado: </div> 
                    <div>{resultado}</div> 

                    <Button onClick={ () => this.ejecutarUpdate()}
                                color='green' size='tiny' >
                        <Icon name="save" />
                        Actualizar
                    </Button>
                </Container>
            );
        }
    }
  
}